import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Container } from '@mui/material';
import Navigation from '@/components/navigation/Navigation';
import { useAuth } from '@/contexts/AuthContext';

const StudentLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated || user?.role !== 'student') {
    return <Navigate to="/login" replace />;
  }

  return (
    <Box 
      sx={{ 
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        overflow: 'hidden'
      }}
    >
      <Navigation 
        variant="default"
        userRole={user?.role}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto'
        }}
      >
        <Container 
          maxWidth="xl" 
          sx={{ 
            mt: 4, 
            mb: 8,
            px: { xs: 4, sm: 6, md: 8 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default StudentLayout;
